/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowsCompare: {
  name: 'arrows-compare';
  data: string;
} = {
  name: 'arrows-compare',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.707 5.707a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L14.414 9H20a1 1 0 1 0 0-2h-5.586l1.293-1.293Zm-6 6.586a1 1 0 0 0-1.414 1.414L9.586 15H4a1 1 0 1 0 0 2h5.586l-1.293 1.293a1 1 0 1 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3Z" fill="currentColor"/></svg>`,
};
